class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);
class CartSelect extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector("select");
    this.line = parseInt(this.select.dataset.index);
    this.size = this.select.value;
    // this.optionIds = {};
    // this.select.getElementsByTagName("option").forEach(option => {
    //   this.optionIds[option.innerHTML.trim()] = option.dataset.variantid;
    // });
    this.options = {};
    this.select.getElementsByTagName("option").forEach(option => {
      this.options[option.innerHTML.trim()] = {};
      this.options[option.innerHTML.trim()].id = option.dataset.variantid;
      this.options[option.innerHTML.trim()].stock = parseInt(option.dataset.stock);
    });
    this.variantId;
  }

  connectedCallback() {
    this.cartItems = this.closest("cart-items");
    this.quantity = parseInt(this.closest(".cart-item").querySelector(".quantity__input").getAttribute("value"));
    // this.variantId = this.optionIds[this.select.value];
    this.variantId = this.options[this.select.value].id;

  }

  makeConfig(variantId) {
    this.config = fetchConfig('javascript');
    this.config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete this.config.headers['Content-Type'];

    var formData = new FormData();
    formData.append("Size", this.select.value);
    formData.append("quantity", this.quantity);
    formData.append("form_type", "product");
    formData.append("id", variantId);

    this.config.body = formData;
    // console.log("CART SELECT CONFIG: /n" + new URLSearchParams(formData).toString())
  }
  // fetch functions
  parseState(state) {
    // console.log("*** SELECTOR FORM RESPONSE ***/n" + JSON.stringify(state));
    return JSON.parse(state);
  }
  createStateObject(parsedState) {
    const parsedStateQuantity = parseInt(parsedState['quantity']);
    return {  parsedState: parsedState, 
              quantity: parsedStateQuantity,
              variantExistsInCart: (!(parsedStateQuantity === this.quantity)), 
              problem: parsedStateQuantity ? false : true }
  }

  problem(stateObject) {
    this.cartItems.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
    this.cartItems.disableLoading();
    const errorWrapper = document.getElementById(`Line-item-error-${this.line}`);
    errorWrapper.querySelector('.cart-item__error-text')
      .innerHTML = stateObject.parsedState.description;
    this.renderKlaviyoButton(errorWrapper);
    this.select.value = this.size;
  }
  renderKlaviyoButton(errorWrapper) {
    if (!errorWrapper.querySelector(".icon-heart-envelope")) errorWrapper.innerHTML += this.querySelector(".klaviyo-notification-wrapper").querySelector("svg").outerHTML;
    errorWrapper.addEventListener("click", () => {
      this.querySelector("a[class='btn klaviyo-bis-trigger']").click();
    });
    // if (this.options[this.select.value].stock === 0) this.querySelector("a[class='btn klaviyo-bis-trigger']").click();
  }

  noProblem(stateObject) {
    this.cartItems.currentItemCount += stateObject.quantity;
    const removeLine = stateObject.variantExistsInCart ? this.line : (this.line + 1);
    return this.cartItems.updateQuantity(removeLine, 0).then(() => { return this.scrollToNewItem(stateObject); });
  }

  scrollToNewItem(stateObject) {
    const cartItem = $(`a[href="${stateObject.parsedState['url']}"`).closest('.cart-item')
    $(".mass-drawer__wrapper").animate({ scrollTop: cartItem.offset().top - cartItem.outerHeight()}, "fast");
  }

  variantATC() {
    console.log(`%c[MassTech / Cart / Cart Select] updating id ${this.options[this.select.value].id} size  ${this.select.value} quantity ${this.quantity}...`, "color: chocolate");
    fetch(`${routes.cart_add_url}`, this.config)
      .then(response => {return response.text();})
      .then(state => this.parseState(state))
      .then(parsedState => this.createStateObject(parsedState))
      .then(stateObject => {return stateObject.problem ? this.problem(stateObject) : this.noProblem(stateObject);})
      // .then(() => alert("completed "))
      .catch(() => {
        this.cartItems.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.querySelectorAll('#cart-errors').forEach(element => element.textContent = window.cartStrings.error);
        this.cartItems.disableLoading();
      })
  }
  onChange() {
    this.cartItems.enableLoading(this.line);
    // this.makeConfig(this.optionIds[this.select.value]);
    this.makeConfig(this.options[this.select.value].id);
    this.variantATC();
    // if (this.options[this.select.value].stock === 0) this.querySelector("a[class='btn klaviyo-bis-trigger']").click();
  }
}
customElements.define('cart-select', CartSelect);
class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      // console.log("CHANGE EVENT : \nevent.target.dataset.index: " + event.target.dataset.index + " /nevent.target.value: " + event.target.value + "\ndocument.activeElement.getAttribute('name'): " + document.activeElement.getAttribute('name'));
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    // console.log("cart items: initialsied");

    this.massDrawer = document.querySelector("mass-drawer");
  }

  onChange(event) {
    event.target.tagName.toUpperCase() === "SELECT".toUpperCase() ? event.target.closest('cart-select').onChange() :
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'))
  }

  getSectionsToRender() {
    var sectionsRender = [
      // {
      //   id: 'main-cart-items',
      //   // section: document.getElementById('main-cart-items').dataset.id || 'main-cart-items',
      //   // selector: '.js-contents',
      //   section: document.querySelector('.cart__items').dataset.id,
      //   selector: '.cart-items__js-contents',
      // },
      // {
      //   id: 'cart-icon-bubble',
      //   section: 'cart-icon-bubble',
      //   selector: '.shopify-section'
      // },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'mass-drawer-progress',
        section: 'mass-drawer',
        selector: '#mass-drawer-progress'
      }, 

      
      // {
      //   id: 'main-cart-footer',
      //   section: document.getElementById('main-cart-footer').dataset.id,
      //   // selector: '.js-contents',
      //   // section: document.querySelector('.cart__footer').dataset.id,
      //   selector: '.cart-footer__js-contents',
      // }
    ];

    document.querySelectorAll('.cart__items').forEach(element => sectionsRender.push({
      id: element.id,
      section: element.dataset.id,
      selector: '.cart-items__js-contents',
    }));
    document.querySelectorAll('.cart__footer__top').forEach(element => sectionsRender.push({
      id: element.id,
      section: element.dataset.id,
      selector: element.dataset.selector, //'.cart-footer__js-contents',
    }));
    document.querySelectorAll('.cart-icon-bubble').forEach(element => sectionsRender.push({
      id: element.id,
      section: element.dataset.id,
      selector: `#${element.id}`
    }));
    sectionsRender.push({
      id: 'mass-drawer',
      section: 'mass-drawer',
      selector: '.mass-drawer__suggestions-media'
    });

    return sectionsRender;
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: [...new Set(this.getSectionsToRender().map((section) => section.section))],
      sections_url: window.location.pathname
    });

    // console.log("*** CART.JS: FORM BODY ***");
    // console.log(JSON.stringify({ ...fetchConfig(), ...{ body } }));
    console.log(`%c[MassTech / Cart] updating line ${line} quantity ${quantity}...`, "color: chocolate");

    return fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        // console.log("*** CART.JS FORM RESPONSE ***");
        // console.log(JSON.stringify(state));
        const parsedState = JSON.parse(state);
        // this.classList.toggle('is-empty', parsedState.item_count === 0);
        document.querySelectorAll('cart-items').forEach(element => element.classList.toggle('is-empty', parsedState.item_count === 0))
        // changed by yuval 
        // const cartFooter = document.getElementById('main-cart-footer');
        // if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        document.querySelectorAll('.cart__footer__top').forEach(element => {
          if (element) element.classList.toggle('is-empty', parsedState.item_count === 0);
        });
        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

          if(section.selector.includes('cart-items')) this.massDrawer.resetIds();
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.massDrawer.renderCompleted();
        document.querySelectorAll("cart-footer").forEach((element) => element.findDynamicElements());
        this.disableLoading();
        console.log(`%c[MassTech / Cart] cart updated`, "color: green");

        return;
      })
      // .then(() => { return new Promise(function (resolve, reject) {resolve('start of new Promise'); }); })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.querySelectorAll('#cart-errors').forEach(element => element.textContent = window.cartStrings.error);
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    // changed by yuval 
    // document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    document.querySelectorAll('.cart__items').forEach(element => element.classList.add('cart__items--disabled'));
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    // changed by Yuval
    // document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
    document.querySelectorAll('.cart__items').forEach(element => element.classList.remove('cart__items--disabled'));
  }
}

customElements.define('cart-items', CartItems);
